export default {"src":"/_next/static/media/calendar.b2400325.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};